import { createSelector } from 'reselect';
const anmDetailsData = (state) => state.anmDetails.anmDetails;
const afDetailsData = (state) => state.anmDetails.anmDetails;
const isDataLoading = (state) => state.anmDetails.isLoading;
const subcenterList = (state) => state.anmDetails.subCenterList;

export const getANMDetails = createSelector([anmDetailsData], (data) => (data)
  );
export const getAFDetails = createSelector([afDetailsData], (data) => (data) );
export const getIsDataLoading = createSelector([isDataLoading], (data) => data);
export const getSubcenterList = createSelector([subcenterList], (data) => data);
